import styles from "./First.module.css";
import Header from "../components/header/Header";

function First({ aboutmeRef, educationRef, experiencesRef, projectsRef, papersRef }) {
  return (
    <div className={styles.firstsection}>
      <Header
        aboutmeRef={aboutmeRef}
        educationRef={educationRef}
        experiencesRef={experiencesRef}
        projectsRef={projectsRef}
        papersRef={papersRef}
      />
      <div className={styles.titles}>
        <h1>SALMANE CHAFIK</h1>
        <h2>Advanced Software Engineer & PhD Student Specializing in Code Generation</h2>
      </div>
    </div>
  );
}
export default First;
